<template>
    <div class="container">
        <a-spin tip="Carregando..." :spinning="spinning">
            <a-config-provider :locale="currentLocale">
                <a-card>
                    <template #title>
                        <a-breadcrumb separator=">">
                            <a-breadcrumb-item>
                                <a href="/configurations/users-groups"><span>Grupos de Usuários</span></a>
                            </a-breadcrumb-item>
                            <a-breadcrumb-item>
                                {{ isEditMode ? 'Editar Grupos de Usuários' : 'Cadastrar Grupo de Usuários' }}
                            </a-breadcrumb-item>
                        </a-breadcrumb>
                    </template>

                    <a-row justify="center" style="margin-bottom: 20px;">
                        <a-col :span="10">
                            <a-input v-model:value="currentData.name" style="width: 100%" placeholder="Descrição" />
                        </a-col>

                        <a-col :span="10">
                            <a-select
                                v-model:value="currentData.department_id"
                                style="width: 100%"
                                show-search
                                :options="departaments"
                                :filter-option="(input, option) =>
                                    option.label.toLowerCase().includes(input.toLowerCase())
                                "
                                placeholder="Departamento"
                                allow-clear
                            />
                        </a-col>
                    </a-row>

                    <fieldset class="fieldset">
                        <legend>Permissões de Menus</legend>
                        <a-row justify="center">
                            <a-col :span="4" v-for="menu of menus" :key="menu.id">
                                <a-collapse>
                                    <a-collapse-panel :header="menu.name" :key="menu.id">
                                        <a-checkbox
                                            v-model:checked="currentData.permission_ids[menu.permission_id]"
                                            @change="onParentCheckboxChange(menu)"
                                        >
                                            Ativar permissão
                                        </a-checkbox>

                                        <!-- Tabela de filhos -->
                                        <a-table :columns="childColumns" :data-source="menu.childrens" bordered>
                                            <template #bodyCell="{ record }">
                                                <a-checkbox
                                                    v-model:checked="currentData.permission_ids[record.permission_id]"
                                                    @change="onChildCheckboxChange(menu, record)"
                                                >
                                                    {{ record.name }}
                                                </a-checkbox>
                                            </template>
                                        </a-table>
                                    </a-collapse-panel>
                                </a-collapse>
                            </a-col>
                        </a-row>
                    </fieldset>

                    <fieldset class="fieldset">
                        <legend>Permissões de Mapas</legend>
                        <a-row justify="center">
                            <a-col :span="8">
                                <a-collapse>
                                    <a-collapse-panel header="Camadas">
                                        <!-- Checkbox para marcar/desmarcar todos -->
                                        <a-checkbox
                                            v-model:checked="allMapsChecked"
                                            @change="toggleAllMaps(true, $event.target.checked)"
                                        >
                                            Marcar Todos
                                        </a-checkbox>

                                        <a-table :columns="[{ title: 'Camadas', dataIndex: 'description', key: 'description' }]" :data-source="maps" bordered>
                                            <template #bodyCell="{ record }">
                                                <a-checkbox
                                                    v-model:checked="currentData.permission_ids[record.permission_id]"
                                                    @change="checkIfAllSelected(true)"
                                                >
                                                    {{ record.description }}
                                                </a-checkbox>
                                            </template>
                                        </a-table>
                                    </a-collapse-panel>
                                </a-collapse>
                            </a-col>

                            <a-col :span="8">
                                <a-collapse>
                                    <a-collapse-panel header="Camadas Temáticas">
                                        <!-- Checkbox para marcar/desmarcar todos -->
                                        <a-checkbox
                                            v-model:checked="allTematicMapsChecked"
                                            @change="toggleAllMaps(false, $event.target.checked)"
                                        >
                                            Marcar Todos
                                        </a-checkbox>

                                        <a-table :columns="[{ title: 'Camadas', dataIndex: 'name', key: 'name' }]" :data-source="tematicMaps" bordered>
                                            <template #bodyCell="{ record }">
                                                <a-checkbox
                                                    v-model:checked="currentData.permission_ids[record.permission_id]"
                                                    @change="checkIfAllSelected(false)"
                                                >
                                                    {{ record.name }}
                                                </a-checkbox>
                                            </template>
                                        </a-table>
                                    </a-collapse-panel>
                                </a-collapse>
                            </a-col>


                        </a-row>
                    </fieldset>

                    <fieldset class="fieldset">
                        <legend>Permissões de Funcionalidades Específicas</legend>
                        <a-row justify="center">
                            <a-col :span="20">
                                <a-table
                                    :columns="[{title:'Funcionalidades Específicas', dataIndex:'description', key:'description'}]"
                                    :data-source="specificFuncs"
                                    :pagination="false"
                                    bordered
                                    :row-class-name="(record) => (!record.status ? 'row-disabled' : '')"
                                >
                                    <template #bodyCell="{ column, record }">
                                        <template v-if="column.key === 'description'">
                                            <div style="display:flex; justify-content:space-between">
                                                <span>{{ record.description }}</span>
                                                <a-switch v-model:checked="currentData.permission_ids[record.permission_id]" :disabled="!record.status" />
                                            </div>
                                        </template>
                                    </template>
                                </a-table>
                            </a-col>
                        </a-row>
                    </fieldset>

                    <a-row justify="center">
                        <a-button
                            style="margin-top: 30px"
                            @click="save"
                            :disabled="currentData.name === ''"
                        >
                            Salvar
                        </a-button>
                    </a-row>
                </a-card>
            </a-config-provider>
        </a-spin>
    </div>
</template>

<script setup>
import {ref, onMounted, computed} from 'vue';
import ptBR from 'ant-design-vue/es/locale/pt_BR';
import { notification } from 'ant-design-vue';
import axios from "axios";
import { openNotification } from '../../../../utils/utilities';

const props = defineProps(["id"]);
const currentLocale = ref(ptBR);
const spinning = ref(false);
const isEditMode = ref()

const route = '/api/configurations/users-groups';
const menus = ref([]);
const maps = ref([])
const tematicMaps = ref([])
const specificFuncs = ref([])

// NOVO: lista de departamentos (departaments)
const departaments = ref([])

const activeKey = ref([]);
const currentData = ref({
    id: null,
    name: '',
    permission_ids: {},
    // NOVO: apenas o id do departamento
    department_id: null,
});

const allMapsChecked = computed(() => maps.value.every(map => currentData.value.permission_ids[map.permission_id]));
const allTematicMapsChecked = computed(() => tematicMaps.value.every(map => currentData.value.permission_ids[map.permission_id]));

const toggleAllMaps = (isGeneralMap, checked) => {
    let list = isGeneralMap ? maps.value : tematicMaps.value;
    list.forEach(map => {
        currentData.value.permission_ids[map.permission_id] = checked;
    });
};

const checkIfAllSelected = (isGeneralMap) => {
    if (isGeneralMap) {
        allMapsChecked.value = maps.value.every(map => currentData.value.permission_ids[map.permission_id]);
    } else {
        allTematicMapsChecked.value = tematicMaps.value.every(map => currentData.value.permission_ids[map.permission_id]);
    }
};

const childColumns = ref([
    { title: 'Filhos', dataIndex: 'name', key: 'name' }
]);

const getMenus = async () =>
    (menus.value = (await window.axios.get('/api/configurations/menus?onlyActives=1')).data.data);
const getMaps = async () => maps.value = (await window.axios.get('/api/maps/layers')).data.data;
const getTematicMaps = async () => tematicMaps.value = (await window.axios.get('/api/maps/thematic-layers')).data.data;
const getSpecificFunctionalities = async () => specificFuncs.value = (await window.axios.get('/api/configurations/specific-functionalities')).data.data;

// NOVO: carregar departamentos
const getDepartaments = async () => {
    const response = await axios.get('/api/e-cidade/departments')
    departaments.value = response.data.data.map(dep => ({
        label: `${dep.coddepto} - ${dep.descrdepto}`,
        value: dep.coddepto,
    }))
}

const onParentCheckboxChange = (menu) => {
    const isChecked = currentData.value.permission_ids[menu.permission_id];

    if (isChecked) {
        activeKey.value = [menu.permission_id];
    } else {
        activeKey.value = [];
    }

    menu.childrens.forEach(child => {
        currentData.value.permission_ids[child.permission_id] = isChecked;
    });
};

const onChildCheckboxChange = (menu, child) => {
    const allUnchecked = menu.childrens.every(c => !currentData.value.permission_ids[c.permission_id]);

    if (allUnchecked) {
        currentData.value.permission_ids[menu.permission_id] = false; // Desmarcar o pai
    } else {
        currentData.value.permission_ids[menu.permission_id] = true; // Marcar o pai
    }
};

const save = async () => {
    let { id, ...data } = currentData.value;
    data.permission_ids = Object.keys(data.permission_ids).filter(key => data.permission_ids[key])
    if (!id) {
        try {
            spinning.value = true;
            const response = await window.axios.post(route, data);
            spinning.value = false;
            openNotification('success', response.data.message);
            await (new Promise(resolve => setTimeout(resolve, 500)));
            window.location.href = `${response.data.data.id}/edit`
        } catch (error) {
            spinning.value = false;
            openNotification('error', error.message);
        }
    } else {
        try {
            spinning.value = true;
            const response = await window.axios.put(`${route}/${id}`, data);
            spinning.value = false;
            openNotification('success', response.data.message);
        } catch (error)            {
            spinning.value = false;
            openNotification('error', error.message);
        }
    }
};

onMounted(async () => {
    await getMenus();
    await getMaps();
    await getTematicMaps();
    await getSpecificFunctionalities();
    // NOVO: carregar departamentos
    await getDepartaments();

    if (props.id) {
        try {
            spinning.value = true
            let register = (await window.axios.get(`${route}/${props.id}`)).data.data
            spinning.value = false
            currentData.value.id = register.id
            currentData.value.name = register.name

            // NOVO: preencher department_id no modo edição (se vier do backend)
            if (register.department_id) {
                currentData.value.department_id = register.department_id
            }

            register.permissions_ids.forEach(permission => {
                currentData.value.permission_ids[permission] = true
            })

            isEditMode.value = true
        } catch (error) {
            spinning.value = false
            openNotification('error', error.message)
        }
    }
});
</script>

<style scoped>
.anticon {
    vertical-align: 2px !important;
}

a-row {
    margin-bottom: 20px;
}

a-col {
    display: flex;
    justify-content: center;
}

.fieldset {
    border: 1px solid #ccc;
    padding: 20px;
    margin-bottom: 20px;
    border-radius: 10px;
    background-color: #f9f9f9;
    display: flex;
    flex-direction: column;
}

fieldset legend {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
}

::v-deep(.row-disabled) {
    background-color: #f5f5f5 !important;
    color: #999 !important;
    opacity: 0.6;
    pointer-events: none;
}
</style>
